import { useMutation, useQuery } from "react-query";
import { filterFetch, normalFetch } from "../../fetch-api/get";
import { useQueryContext } from "../../../contexts/query";
import { postApi } from "../../fetch-api/post";
import { patchApi } from "../../fetch-api/patch";
import { deleteApi } from "../../fetch-api/delete";


export const packageKeys = {
    getPackages: 'getPackages',
    getPackage: 'getPackage',
    setPackage: 'setPackage',
    editPackage: 'editPackage',
    deletePackage: 'deletePackage',
}

export const useGetPackages = () => {

    return useQuery(
        packageKeys.getPackages, () => normalFetch('plan'),
        {
            select: res => res?.data?.data
        }
    )
}
export const useGetAPackageWithId = ({ id, enabled }) => {

    return useQuery(
        packageKeys.getPackage, () => normalFetch(`plan/${id}`),
        {
            enabled: enabled,
            select: res => res?.data?.data
        }
    )
}

export const useAddPackage = (onSuccess = () => { }) => {

    const { queryClient, setToast } = useQueryContext()

    return useMutation(
        packageKeys.setPackage, (payload) => postApi(payload, 'plan'),
        {
            onSuccess: () => {
                setToast({ message: `package-add-success`, show: true })
                queryClient.invalidateQueries([packageKeys.getPackages])
                onSuccess()
            }
        }
    )
}

export const useEditPackage = (onSuccess = () => { }) => {

    const { queryClient, setToast } = useQueryContext()

    return useMutation(
        packageKeys.editPackage, (payload) => patchApi(payload, `plan/${payload.id}`),
        {
            onSuccess: () => {
                setToast({ message: `package-edit-success`, show: true })
                queryClient.invalidateQueries([packageKeys.getPackages])
                onSuccess()
            }
        }
    )
}

export const useDelPackage = (onSuccess = () => { },) => {

    const { queryClient, setToast } = useQueryContext()

    return useMutation(
        packageKeys.deletePackage, (id) => deleteApi(`plan/${id}`),
        {
            onSuccess: () => {
                setToast({ message: `package-delete-success`, show: true })
                queryClient.invalidateQueries([packageKeys.getPackages])
                onSuccess()
            }
        }
    )
}

